"use strict";

exports.__esModule = true;
var _BannerRow = _interopRequireDefault(require("./BannerRow"));
exports.default = _BannerRow.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}